import { Salonized } from '../translations-types';

const translations: Salonized = {
  title: 'Salonized-koppeling',
  description: 'Koppel je Salonized-account zodat de agenda per medewerker in Re-sence getoond kan worden.',
  connected: 'Gekoppeld',
  notConnected: 'Niet gekoppeld',
  connectedAs: 'Gekoppeld als',
  email: 'Salonized e-mailadres',
  password: 'Salonized wachtwoord',
  url: 'Salonized agenda-URL',
  urlHelp: 'Bijv. https://app.salonized.com/c/1234/l/1234/calendar',
  connect: 'Koppelen',
  disconnect: 'Ontkoppelen',
  connectSuccess: 'Salonized gekoppeld',
  disconnectSuccess: 'Salonized ontkoppeld',
  sync: 'Synchroniseer nu',
  syncPastYear: 'Synchroniseer afgelopen jaar',
  deleteAppointments: 'Verwijder alle afspraken',
  deleteAppointmentsConfirm: 'Weet je zeker dat je alle gesynchroniseerde afspraken wilt verwijderen?',
  deleteAppointmentsSuccess: 'Alle gesynchroniseerde afspraken verwijderd',
  syncing: 'Synchroniseren…',
  syncDone: 'Synchronisatie voltooid',
  added: 'Toegevoegd',
  updated: 'Bijgewerkt',
  removed: 'Verwijderd',
  matchedCustomers: 'Gematchte klanten',
  unmatchedCustomers: 'Niet-gematchte klanten',
  ambiguous: 'Meerdere matches',
};

export default translations;
